export const GetSpin = "GetSpin";

export function changeSpin(subreddit: any) {
  return {
    type: GetSpin,
    rs: subreddit
  };
}